export const endInfoPage = {
    addFlightInfo: ['Доп. сведения о рейсе', 'Additional flight info'],
    addFuelInfo: ['Доп. сведения о топливе', 'Additional fuel info'],
    biologicalNight: ['Биологическая ночь', 'Biological night'],
    dist: ['Дистанция', 'Distance'],
    dutyComment: ['Комментарий по смене', 'Duty comment'],
    dutyCommentLabel: [
        'Комментарий по смене (будет показан на странице с итоговой информацией)',
        'Duty comment (will be shown on Summary info page)',
    ],
    dutyTime: ['Рабочее время ', 'Duty time '],
    dutyTimeEnded: ['Окончание смены', 'Duty time ended on'],
    dutyTimeLeg: ['Рабочее время на участке ', 'Duty time on leg '],
    endDutyTime: ['Завершить смену', 'End duty time'],
    endLegTime: ['Завершить участок', 'End leg time'],
    flightNight: ['Ночной налёт', 'Flight night'],
    fuelRemainInfo: ['Сведения об остатке топлива', 'Fuel remain info'],
    ground: ['Расход на земле', 'Ground'],
    holdTime: ['Время ожидания', 'Hold time'],
    instrumentalFlight: ['Налёт по приборам', 'Instrumental flight'],
    landingDevice: ['Посадки по приборам', 'Landing on device'],
    landings: ['Посадки', 'Landings'],
    legTimeEnded: ['Окончание работы на участке', 'Leg time ended on'],
    parkingTime: ['Время стоянки', 'Parking time'],
    postFlightTime: ['Послеполётное время ', 'Post-flight time '],
    refueling: ['Дозаправка', 'Refueling'],
    remain: ['Остаток', 'Remain'],
    restTime: ['Время отдыха', 'Rest time'],
    subtotalDutyTime: ['Рабочее время участка ', 'Subtotal duty time '],
    taxiIN: ['Расход на руление', 'Taxi IN'],
};
